import React, { Fragment } from 'react';
import {ReactSVG} from "react-svg";
import {getPublicImagePath} from "@nutastic/nutastic-react-app";

const AppLoading = () => {
    const componentClass = "loading-app-page";
    const isHomePage = window.location.pathname === '/'; //TODO: put this in react-app

    return isHomePage ? <div className={componentClass}>
        <img src={getPublicImagePath('itsUp.png')} className={`${componentClass}__img animated zoomIn`} />
        <ReactSVG src="/public/assets/img/page-loader.svg" className={`${componentClass}__svg`} />
    </div> : null;
};

export default AppLoading;
